<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap justify-center align-center>
      <v-flex md8 xs12>
        <v-card>
          <card-toolbar title="İptal İşlemleri">
            <v-flex d-flex>
              <v-layout justify-end>
                <v-btn
                        v-if="data.cancelKeyword"
                  :depressed="updatingItem.state"
                  color="primary"
                  @click="updatingCancel">
                  {{ stateText }}
                </v-btn>
              </v-layout>
            </v-flex>
          </card-toolbar>
          <v-card-text>
            <v-layout row>
              <v-alert type="warning">
                İptal Kodu ve İptal Linki hizmetlerinizin bulunması durumunda mesaj gönderim ekranlarında bu seçenekler aktif olacak ve gönderilen mesajlara aşağıdaki iptal seçenekleri eklenecektir.
              </v-alert>
              <v-flex xs12>
                <v-flex xs12>
                  <v-text-field
                    :value="keyword"
                    label="İptal Kodu"
                    disabled>
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    :value="link"
                    label="İptal Linki"
                    disabled>
                  </v-text-field>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-expand-transition>
        <v-flex md6 xs12 v-if="updatingItem.state">
          <v-card>
            <card-toolbar title="Kısakod Güncelleme"></card-toolbar>
            <v-card-text>
              <v-layout row>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-checkbox
                        v-model="updatingItem.edit.auto_reply"
                        label="Otomatik Cevapla">
                      </v-checkbox>
                    </v-flex>
                    <v-flex xs12>
                      <senders-or-message-types
                        label="Gönderici Adı"
                        no-data-text="Aktif Gönderici Adı bulunmuyor"
                        required=""
                        :rules="[$rules.selection('Gönderici Adı')]"
                        :default="data.senders[0]"
                        :items="data.senders"
                        @on:model-update="(val) => { updatingItem.edit.sender = val; }">
                      </senders-or-message-types>
                    </v-flex>
                    <v-flex xs6>
                      <v-textarea

                        shaped
                        label="Kabul Cevabı"
                        v-model="updatingItem.edit.accept_reply"
                        :rules="[$rules.empty('Kabul cevabı')]"
                        clearable>
                      </v-textarea>
                    </v-flex>
                    <v-flex xs6>
                      <v-textarea
                        shaped

                        label="Red Cevabı"
                        v-model="updatingItem.edit.reject_reply"
                        :rules="[$rules.empty('Red cevabı')]"
                        clearable>
                      </v-textarea>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-end>
                    <v-btn color="secondary" @click="updateCancel">güncelle</v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-expand-transition>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import CardToolbar from '../../Components/CardToolbar.vue';
import SendersOrMessageTypes from '../../Components/SMSConstants/SendersOrMessageTypes.vue';

export default {
  name: 'Cancel',
  components: { SendersOrMessageTypes, CardToolbar },
  data: () => ({
    updatingItem: {
      edit: {},
      state: false,
    },
    data: {},
  }),
  methods: {
    ...mapActions({ asyncSend: 'asyncSender' }),
    ...mapActions({ send: 'sendBackend' }),
    updateCancel() {
      this.send({ route: 'update/cancel', data: this.updatingItem.edit });
    },
    async updatingCancel() {
      this.updatingItem.edit = this.data.cancelKeyword;
      this.updatingItem.state = !this.updatingItem.state;
      this.updatingItem.edit.auto_reply = this.updatingItem.edit.auto_reply !== '0';
    },
  },
  computed: {
    stateText() {
      return this.updatingItem.state ? 'iptal et' : 'güncelle';
    },
    link() {
      if (this.data.cancelLink) {
        return this.data.cancelLink.bitly;
      }
      return 'Hesabınıza tanımlı iptal linki bulunmamakta';
    },
    keyword() {
      if (this.data.cancelKeyword) {
        return `${this.data.cancelKeyword.keyword} (Bitiş Tarihi: ${this.data.cancelKeyword.end_date})`;
      }
      return 'Hesabınıza tanımlı iptal kodu bulunmamakta';
    },
  },
  created() {
    this.send({ route: 'show/cancel' })
      .then((r) => {
        this.data = r.data.data;
      });
  },
};
</script>
